export const STORAGE_EVENT = 'localStorageChange'

export const storageService = {
  setItem(key, value, currTabEvent) {
    localStorage.setItem(key, value)
    if (currTabEvent) {
      window.dispatchEvent(
        new CustomEvent(STORAGE_EVENT, {
          detail: { key, value },
        }),
      )
    }
  },

  removeItem(key, currTabEvent) {
    localStorage.removeItem(key)
    if (currTabEvent) {
      window.dispatchEvent(
        new CustomEvent(STORAGE_EVENT, {
          detail: { key },
        }),
      )
    }
  },
}

